import { render, staticRenderFns } from "./loging.vue?vue&type=template&id=4ab972db&scoped=true&"
import script from "./loging.vue?vue&type=script&lang=js&"
export * from "./loging.vue?vue&type=script&lang=js&"
import style0 from "./loging.vue?vue&type=style&index=0&id=4ab972db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab972db",
  null
  
)

export default component.exports